import { ICopyFileOptions, IFile, IFilePath, IHeaders, IMoveFileOptions, IStorageUnit } from '../../FrontApplet/FileSystem/types';
import { EmptyObject } from '../EmptyObject';

export declare type FileSystemRequests =
	| FileSystemListOfStorageUnitsRequest
	| FileSystemListOfInternalStorageUnitsRequest
	| FileSystemListFilesRequest
	| FileSystemIsDirectoryRequest
	| FileSystemExistsRequest
	| FileSystemDeleteFileRequest
	| FileSystemCreateDirectoryRequest
	| FileSystemDownloadFileRequest
	| FileSystemWriteFileRequest
	| FileSystemReadFileRequest
	| FileSystemMoveFileRequest
	| FileSystemCopyFileRequest
	| FileSystemGetFileChecksumRequest
	| FileSystemExtractFileRequest
	| FileSystemGetFileRequest
	| FileSystemAppendFileRequest
	| FileSystemCreateArchiveFileRequest
	| FileSystemWipeoutRequest
	| FileSystemLinkRequest;

export const FileSystemListOfStorageUnitsRequest = 'sos.Monitoring.FileSystem.FileSystemListOfStorageUnitsRequest';
export interface FileSystemListOfStorageUnitsRequest {
	type: typeof FileSystemListOfStorageUnitsRequest;
}

export const FileSystemListOfStorageUnitsResult = 'sos.Monitoring.FileSystem.FileSystemListOfStorageUnitsResult';
export interface FileSystemListOfStorageUnitsResult {
	type: typeof FileSystemListOfStorageUnitsResult;
	storageUnits: IStorageUnit[];
}

export const FileSystemListOfInternalStorageUnitsRequest = 'sos.Monitoring.FileSystem.FileSystemListOfInternalStorageUnitsRequest';
export interface FileSystemListOfInternalStorageUnitsRequest {
	type: typeof FileSystemListOfInternalStorageUnitsRequest;
}

export const FileSystemListOfInternalStorageUnitsResult = 'sos.Monitoring.FileSystem.FileSystemListOfInternalStorageUnitsResult';
export interface FileSystemListOfInternalStorageUnitsResult {
	type: typeof FileSystemListOfInternalStorageUnitsResult;
	storageUnits: IStorageUnit[];
}
export const FileSystemListFilesRequest = 'sos.Monitoring.FileSystem.FileSystemListFilesRequest';
export interface FileSystemListFilesRequest {
	type: typeof FileSystemListFilesRequest;
	filePath: IFilePath;
}

export const FileSystemListFilesResult = 'sos.Monitoring.FileSystem.FileSystemListFilesResult';
export interface FileSystemListFilesResult {
	type: typeof FileSystemListFilesResult;
	pathList: IFilePath[];
}

export const FileSystemIsDirectoryRequest = 'sos.Monitoring.FileSystem.FileSystemIsDirectoryRequest';
export interface FileSystemIsDirectoryRequest {
	type: typeof FileSystemIsDirectoryRequest;
	filePath: IFilePath;
}

export const FileSystemIsDirectoryResult = 'sos.Monitoring.FileSystem.FileSystemIsDirectoryResult';
export interface FileSystemIsDirectoryResult {
	type: typeof FileSystemIsDirectoryResult;
	result: boolean;
}

export const FileSystemExistsRequest = 'sos.Monitoring.FileSystem.FileSystemExistsRequest';
export interface FileSystemExistsRequest {
	type: typeof FileSystemExistsRequest;
	filePath: IFilePath;
}

export const FileSystemExistsResult = 'sos.Monitoring.FileSystem.FileSystemExistsResult';
export interface FileSystemExistsResult {
	type: typeof FileSystemExistsResult;
	result: boolean;
}

export const FileSystemDeleteFileRequest = 'sos.Monitoring.FileSystem.FileSystemDeleteFileRequest';
export interface FileSystemDeleteFileRequest {
	type: typeof FileSystemDeleteFileRequest;
	filePath: IFilePath;
	recursive: boolean;
}

export const FileSystemDeleteFileResult = 'sos.Monitoring.FileSystem.FileSystemDeleteFileResult';
export interface FileSystemDeleteFileResult {
	type: typeof FileSystemDeleteFileResult;
	result: EmptyObject;
}

export const FileSystemCreateDirectoryRequest = 'sos.Monitoring.FileSystem.FileSystemCreateDirectoryRequest';
export interface FileSystemCreateDirectoryRequest {
	type: typeof FileSystemCreateDirectoryRequest;
	directoryPath: IFilePath;
}

export const FileSystemCreateDirectoryResult = 'sos.Monitoring.FileSystem.FileSystemCreateDirectoryResult';
export interface FileSystemCreateDirectoryResult {
	type: typeof FileSystemCreateDirectoryResult;
	result: EmptyObject;
}

export const FileSystemDownloadFileRequest = 'sos.Monitoring.FileSystem.FileSystemDownloadFileRequest';
export interface FileSystemDownloadFileRequest {
	type: typeof FileSystemDownloadFileRequest;
	filePath: IFilePath;
	sourceUri: string;
	headers?: IHeaders | undefined;
}

export const FileSystemDownloadFileResult = 'sos.Monitoring.FileSystem.FileSystemDownloadFileResult';
export interface FileSystemDownloadFileResult {
	type: typeof FileSystemDownloadFileResult;
	result: EmptyObject;
}

export const FileSystemWriteFileRequest = 'sos.Monitoring.FileSystem.FileSystemWriteFileRequest';
export interface FileSystemWriteFileRequest {
	type: typeof FileSystemWriteFileRequest;
	filePath: IFilePath;
	content: string;
}

export const FileSystemWriteFileResult = 'sos.Monitoring.FileSystem.FileSystemWriteFileResult';
export interface FileSystemWriteFileResult {
	type: typeof FileSystemWriteFileResult;
	result: EmptyObject;
}

export const FileSystemReadFileRequest = 'sos.Monitoring.FileSystem.FileSystemReadFileRequest';
export interface FileSystemReadFileRequest {
	type: typeof FileSystemReadFileRequest;
	filePath: IFilePath;
}

export const FileSystemReadFileResult = 'sos.Monitoring.FileSystem.FileSystemReadFileResult';
export interface FileSystemReadFileResult {
	type: typeof FileSystemReadFileResult;
	data: string;
}

export const FileSystemMoveFileRequest = 'sos.Monitoring.FileSystem.FileSystemMoveFileRequest';
export interface FileSystemMoveFileRequest {
	type: typeof FileSystemMoveFileRequest;
	sourceFilePath: IFilePath;
	destinationFilePath: IFilePath;
	options: IMoveFileOptions | object;
}

export const FileSystemMoveFileResult = 'sos.Monitoring.FileSystem.FileSystemMoveFileResult';
export interface FileSystemMoveFileResult {
	type: typeof FileSystemMoveFileResult;
	result: EmptyObject;
}

export const FileSystemCopyFileRequest = 'sos.Monitoring.FileSystem.FileSystemCopyFileRequest';
export interface FileSystemCopyFileRequest {
	type: typeof FileSystemCopyFileRequest;
	sourceFilePath: IFilePath;
	destinationFilePath: IFilePath;
	options: ICopyFileOptions | object;
}

export const FileSystemCopyFileResult = 'sos.Monitoring.FileSystem.FileSystemCopyFileResult';
export interface FileSystemCopyFileResult {
	type: typeof FileSystemCopyFileResult;
	result: EmptyObject;
}

export const FileSystemGetFileChecksumRequest = 'sos.Monitoring.FileSystem.FileSystemGetFileChecksumRequest';
export interface FileSystemGetFileChecksumRequest {
	type: typeof FileSystemGetFileChecksumRequest;
	filePath: IFilePath;
	hashType: string;
}

export const FileSystemGetFileChecksumResult = 'sos.Monitoring.FileSystem.FileSystemGetFileChecksumResult';
export interface FileSystemGetFileChecksumResult {
	type: typeof FileSystemGetFileChecksumResult;
	result: string;
}

export const FileSystemExtractFileRequest = 'sos.Monitoring.FileSystem.FileSystemExtractFileRequest';
export interface FileSystemExtractFileRequest {
	type: typeof FileSystemExtractFileRequest;
	archiveFilePath: IFilePath;
	destinationDirectionPath: IFilePath;
	method: string;
}

export const FileSystemCreateArchiveFileRequest = 'sos.Monitoring.FileSystem.FileSystemCreateArchiveFileRequest';
export interface FileSystemCreateArchiveFileRequest {
	type: typeof FileSystemCreateArchiveFileRequest;
	archiveFilePath: IFilePath;
	archiveEntries: IFilePath[];
}

export const FileSystemCreateArchiveFileResult = 'sos.Monitoring.FileSystem.FileSystemCreateArchiveFileResult';
export interface FileSystemCreateArchiveFileResult {
	type: typeof FileSystemCreateArchiveFileResult;
	result: EmptyObject;
}

export const FileSystemExtractFileResult = 'sos.Monitoring.FileSystem.FileSystemExtractFileResult';
export interface FileSystemExtractFileResult {
	type: typeof FileSystemExtractFileResult;
	result: EmptyObject;
}

export const FileSystemGetFileRequest = 'sos.Monitoring.FileSystem.FileSystemGetFileRequest';
export interface FileSystemGetFileRequest {
	type: typeof FileSystemGetFileRequest;
	filePath: IFilePath;
}

export const FileSystemGetFileResult = 'sos.Monitoring.FileSystem.FileSystemGetFileResult';
export interface FileSystemGetFileResult {
	type: typeof FileSystemGetFileResult;
	file: IFile | null;
}

export const FileSystemAppendFileRequest = 'sos.Monitoring.FileSystem.FileSystemAppendFileRequest';
export interface FileSystemAppendFileRequest {
	type: typeof FileSystemAppendFileRequest;
	filePath: IFilePath;
	content: string;
}

export const FileSystemAppendFileResult = 'sos.Monitoring.FileSystem.FileSystemAppendFileResult';
export interface FileSystemAppendFileResult {
	type: typeof FileSystemAppendFileResult;
	result: EmptyObject;
}

export const FileSystemWipeoutRequest = 'sos.Monitoring.FileSystem.FileSystemWipeoutRequest';
export interface FileSystemWipeoutRequest {
	type: typeof FileSystemWipeoutRequest;
}

export const FileSystemWipeoutResult = 'sos.Monitoring.FileSystem.FileSystemWipeoutResult';
export interface FileSystemWipeoutResult {
	type: typeof FileSystemWipeoutResult;
	result: EmptyObject;
}

export const FileSystemLinkRequest = 'sos.Monitoring.FileSystem.FileSystemLinkRequest';
export interface FileSystemLinkRequest {
	type: typeof FileSystemLinkRequest;
	sourceFilePath: IFilePath;
	destinationFilePath: IFilePath;
}

export const FileSystemLinkResult = 'sos.Monitoring.FileSystem.FileSystemLinkResult';
export interface FileSystemLinkResult {
	type: typeof FileSystemLinkResult;
	result: EmptyObject;
}
